define('shared/initializer/form/adapters/mixins/UpdateMemberInfoInMemberPage',[
    'shared/lib/RSVP',
    'shared/util/fields/common',
    'shared/my/identity',
    'shared/my/cmus',
    'shared/initializer/form/constants',
    'shared/util/checkout/member'
],
function (
    RSVP, 
    fieldUtil, 
    getIdentity, 
    getCMus,
    constants, 
    memberUtil
) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doPageLoad = function(){
        if(!memberUtil.isUpdatingMemberInfo()){
            return RSVP.resolve();
        }

        var me = this;
        var items = me.items;
        var curItem;

        for (var key in items) {
            if (!items.hasOwnProperty(key) || 
                key == constants.FIELD.LOCATION_COUNTRY || 
                key == constants.FIELD.LOCATION_STATE || 
                key == constants.FIELD.LOCATION_CITY || 
                key == constants.FIELD.PHONE_TYPE || 
                key == constants.FIELD.PHONE || 
                key == constants.FIELD.TOC) {
                continue;
            }

            curItem = items[key];
            if (!curItem.$el.is('[type=hidden]')) {
                curItem.$el.prop('disabled', 'disabled');
            }
        }

        var pwdField = items[constants.FIELD.PASSWORD];
        if(pwdField && pwdField.$el){
            pwdField.$el.val('******');
        }

        return RSVP.resolve();
    };

    Ctor.prototype.doBeforeSubmit = function(){
        if(!memberUtil.isUpdatingMemberInfo()){
            return RSVP.resolve();
        }

        var me = this;
        var $form = me.$form;

        $form.prop('action', constants.ServiceUrl.UpdateMember);

        var setFieldValue = fieldUtil.setFieldValue;

        return RSVP.all([getIdentity(), getCMus()]).then(function(values){
            var memberId = values[0];
            var cmus = values[1];

            setFieldValue(cmus, constants.FIELD.CMUS, $form);
            setFieldValue('', constants.FIELD.PASSWORD, $form);
            setFieldValue('', constants.FIELD.MemberPassword, $form);
            setFieldValue(memberId, constants.FIELD.MemeberMemberId, $form);
        });
    };

    return Ctor;
});

